import createReducer from '../../utils/createReducer';
import actionPrefix from '../../utils/actionPrefix';
import { fetchScratchpad } from './scratchpad';
import { fetchRecentActivity } from './recentActivity';

const initialState = {};

const prefix = actionPrefix('user');

// Actions
const UPDATE_USER = prefix('UPDATE_USER');

// Reducers
export default createReducer(initialState, {
  [UPDATE_USER](state, { payload }) {
    return {
      ...state,
      ...payload,
      isUserLogged: true
    };
  }
});

// Action creators
export const updateUser = userData => ({
  type: UPDATE_USER,
  payload: userData
});

// Selectors
const getExperimentValue = (state, name) =>
  state.abacus.experiments[name] && state.abacus.experiments[name].value;

// Effects
export const fetchUser = ({ publicUuid }) => (dispatch, getState) => {
  if (publicUuid) {
    const experimentValue = getExperimentValue(getState(), 'HA_PTA_HP_RecentActivityOptimizationV2');
    window.analyticsdatalayer.publicuuid = publicUuid;
    dispatch(updateUser({ publicUuid }));

    if (experimentValue === 1) {
      dispatch(fetchRecentActivity());
    } else {
      dispatch(fetchScratchpad());
    }
  } else {
    window.location.reload();
  }
};
